module.exports = __webpack_public_path__ + "static/media/UserCat.97ec0c4d.png";